import * as React from "react";
import styled from "styled-components";

import i18n from "../../lib/i18n";
import { Country } from "../../common/actions/Auth";
import { media } from "../../common/utils/style";
import { Company } from "../entities";
import TogglableStyledInput from "../../common/components/TogglableStyledInput";
import { NavigatableSection } from "./Section";

interface Props {
  company: Company;
  locale: string;
  country: Country;
  editable?: boolean;
  onChange?(company: Company): void;
}

class MissionSection extends React.PureComponent<Props> {
  public onChangeMissionStatement = (text: string) => {
    const { company, onChange } = this.props;
    onChange!({ ...company, mission_statement: text });
  };

  public onChangeOrigin = (text: string) => {
    const { company, onChange } = this.props;
    onChange!({ ...company, origin: text });
  };

  public maxWordLengthOfMission = (country: Country) => {
    return country === "japan" ? 30 : 80;
  };

  public render() {
    const { company, locale, editable, country } = this.props;
    const canShow = Boolean(company.mission_statement || company.origin || editable);
    return (
      <>
        {canShow && (
          <Section id="mission" displayName={i18n.translate("company.home.sections.mission", { locale })}>
            <Mission
              component="h2"
              value={company.mission_statement || ""}
              editable={editable}
              multiLine={false}
              onChange={this.onChangeMissionStatement}
              placeholder={i18n.translate("company.home.add_tagline", { locale })}
              maxLength={this.maxWordLengthOfMission(country)}
            />
            <Origin
              component="p"
              value={company.origin || ""}
              editable={editable}
              multiLine
              onChange={this.onChangeOrigin}
              placeholder={i18n.translate("company.home.add_description", { locale })}
              maxLength={255}
            />
          </Section>
        )}
      </>
    );
  }
}

export const Section = styled(NavigatableSection)`
  position: relative;
  margin: 0 17px;
  color: rgba(0, 0, 0, 0.8);
  @media ${media.large} {
    width: 680px;
    padding: 0;
    margin: -30px auto 0;
    &:first-of-type {
      margin-top: -30px;
    }
  }
`;

export const Mission = styled(TogglableStyledInput)`
  width: 100%;
  margin-bottom: 12px;
  box-sizing: border-box;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.45;
  color: rgba(0, 0, 0, 0.8);
  outline: none;
  @media ${media.large} {
    font-size: 44px;
    margin-bottom: 23px;
  }
`;

export const Origin = styled(TogglableStyledInput)`
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.71;
  text-align: left;
  color: rgba(0, 0, 0, 0.56);
  outline: none;
  white-space: pre-wrap;
  @media ${media.large} {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.88;
    text-align: left;
  }
`;

export default MissionSection;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/MissionSection.tsx